import React from 'react';
import { Box } from '@mui/material';
import Sidebar from './Sidebar';
import ProfileForm from './ProfileForm';

const MyProfile = () => {
    return (
        <Box sx={{ display: 'flex' }}>
            <Sidebar />
            <Box sx={{ marginTop:3 }}>
                <ProfileForm />
            </Box>
        </Box>
    );
};

export default MyProfile;